<div class="user-terms-conditions-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'PPTermsAndConditions'|translate}}</h2>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="spinner-container">
        <div class="terms" [innerHTML]="termsConditions"></div>
        <upsc-element-blocker *ngIf="isTermsLoading"></upsc-element-blocker>
    </mat-dialog-content>
</div>
